import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import { message, loader } from '@/libs/helper';
import { getIamRole, deleteIamRole, copyIamRole } from '@/libs/api/api';
import constants from '@/libs/constant/constants';
import { isEmpty } from 'lodash';
import BulkUpdate from './BulkUpload/BulkUpdate.vue'
export default {
    components:{
        SettingsDropdown,
        BulkUpdate
    },
    data() {
        return {
            isEmpty,
            searchValue: '',
            columns: ['roles_checkbox_all', 'role', 'type', 'for', 'permissions', 'settings'],
            rolesTableData: [],
            rolesTableSettings: {
                headings: {
                    roles_checkbox_all: '',
                    role: 'Role',
                    type: 'Type',
                    for: 'For',
                    permissions: 'Permissions',
                    settings: ''
                },
                pagination: { show: true},
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                perPageValues:[]
            },
            selectedEntries: [],
            category: '',
            sort: 'name',
            order: 'asc',
            limit: 25,
            currentPage: 1,
            skip: 0,
            previousPage : 1,
            rolesCount: {},
            pageSize: '10',
            tableDataCount: null,
            isBulkEdit: false,
            selectedRoleNames: [],
            isRemoveRole: false,
            isAllRolesSelected: false
        }
    },
    mounted() {
        this.fetchIamRoles()
    },
    computed: {
        perPageSelect: {
            get(){
                return this.pageSize
            },
            set(val){
                this.pageSize = val
                this.skip=0
                this.currentPage = 1
                this.fetchIamRoles()
            }
        },
        params() {
            return `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
        },
        orgID() {
            return this.$attrs.currentOrganisation._id
        }
    },
    methods: {
        async fetchIamRoles() {
            loader(this, true)
            let params = this.params
            let searchValue = this.searchValue
            let body = {searchText: searchValue}
            await getIamRole(this.orgID, params, body)
                .then((response) => {
                    loader(this, false)
                    this.tableDataCount = response.result.total_count
                    this.rolesTableData = response.result.items.map((role) => {
                        return {
                            role: role.name,
                            type: role.type,
                            permissions: role.permission_id,
                            _id: role._id,
                            for: role.role_for
                        }
                    })
                })
                .catch((error) => {
                    message(this, constants.messageType.ERROR, (error))
                    loader(this, false)
                })
        },
        async querySearch (query, cb) {
            if(query === undefined || query === '' || query.length < 2){
                return
            }
            let searchResult = []
            try{
                let params = ''
                let body = {searchText: query}
                await getIamRole(this.orgID, params, body).then((res) => {
                    searchResult = res.result.items
                })
            }catch(error){
                console.log("error",error)
                return error
                
            }
            // call callback function to return suggestion objects
            cb(searchResult);
        },
        handleSelectValue(val) {
            this.searchValue = val.name || val.value
            this.fetchIamRoles()
        },
        handleCheckBoxSelect(row) {
            let id = row._id
            if (!this.selectedEntries.includes(id)) {
                this.selectedEntries.push(id)
                this.selectedRoleNames.push(row.role)
            } else {
                const index = this.selectedEntries.indexOf(id)
                const nameIndex = this.selectedRoleNames.indexOf(row.role)
                if (index > -1) {
                    this.selectedEntries.splice(index, 1);
                }
                if (nameIndex > -1) {
                    this.selectedRoleNames.splice(nameIndex, 1)
                }
            }

        },
        async clearSearchInput() {
            this.searchValue = ''
            this.skip = 0
            this.currentPage = 1
            await this.fetchIamRoles()
        },
        gotoCreateRoleGroup() {
            this.$router.push({ path: `iam-roles/create`})
        },
        handleCommand(command, data) {
            switch (command) {
                case 'EDIT_ROLE':
                    this.editRole(data)
                    break
                case 'DELETE':
                    this.deleteRole(data)
                    break
                case 'VIEW_ROLE':
                    console.log(data)
                    this.viewRole(data)
                    break
                case 'COPY_ROLE': 
                    this.copyRole(data)
                    break
                    
            }
        },
        async deleteRole(group) {
            const mainTitle = `${window.i18next.t(`Remove role`)} `;
            const nameTitle = `${group.role}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a role, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the role, it can not be undone')}?
                    </div>                    
                </div>`
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(() => {
                    // call api of delete 
                    loader(this, true)
                    deleteIamRole(this.orgID, group._id).then(async (res) => {
                        if(res.message === 'role_already_in_use') {
                            message(this, constants.messageType.ERROR, this.$t(`${res.message}`, {count: res.count}))
                        } else {
                            message(this, constants.messageType.SUCCESS, (res.message))
                        }
                        loader(this, false)
                    this.fetchIamRoles();
                    }).catch((error) => {
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                }).catch(() => {})
        },
        viewRole(role) {
            let id = role && role._id
            this.$router.push({ path: `iam-roles/view/${id}` })
        },
        editRole(group) {
            let id = group && group._id
            this.$router.push({ path: `iam-roles/edit/${id}` })
        },
        async copyRole(role) {
            let id = role && role._id
            await copyIamRole(id).then((res) => {
                message(this, constants.messageType.SUCCESS, (res.message))
                this.fetchIamRoles()
            }).catch((err) => {
                message(this, constants.messageType.ERROR, (err.message))
            })
        },
        changeSort(sortingKey) {
            this.sortingOrder = this.sortingKey !== sortingKey ? 'desc' : this.sortingOrder === 'desc' ? 'asc' : 'desc'
            this.sortingKey = sortingKey
            this.sorting(this.sortingOrder, this.sortingKey)
        },
        sorting(order, sort) {
            // this.skip = 0
            this.order = order
            // this.currentPage = 1
            this.sort = sort
            this.fetchIamRoles()
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            // call api and and set updated data
            this.fetchIamRoles()
        },
        bulkEdit () {
            this.isBulkEdit = true
        },
        clearAllSelection () {
            this.selectedEntries = []
            this.selectedRoleNames = []
            this.isBulkEdit = false
            this.clearSearchInput()
        },
        closeRemovePopup() {
            this.isRemoveRole = false
        },
        selectAllRoles(event) {
            this.isAllRolesSelected = event
            if (this.isAllRolesSelected) {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (!row.isdefault && row.type !== 'Accura Managed' && this.searchValue !== row._id && index === -1) {
                        this.selectedEntries.push(row._id)
                        this.selectedRoleNames.push(row.role)
                    }
                })
            } else {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (index > -1 && !row.isdefault) {
                        this.selectedEntries.splice(index, 1);
                        this.selectedRoleNames.splice(row.role, 1)
                    }
                })
            }
        },
    }
}